/**
 * The page's four places to stand, and where every link ever written to it goes.
 *
 * `?tab=` has been a link into this page since before the command center
 * existed, and it has broken twice when the tabs changed. The names on screen
 * changed again (Reports, Subscriptions, Delivery History and Report Branding
 * Guidelines became Library, Schedules, Deliveries and Branding) and none of
 * the old addresses may stop working, so every one of them is listed here.
 */

export type ReportingTab = 'library' | 'schedules' | 'deliveries' | 'branding'

export const REPORTING_TABS: Array<{ id: ReportingTab; label: string }> = [
  { id: 'library', label: 'Library' },
  { id: 'schedules', label: 'Schedules' },
  { id: 'deliveries', label: 'Deliveries' },
  { id: 'branding', label: 'Branding' },
]

const ALIASES: Record<string, ReportingTab> = {
  library: 'library',
  reports: 'library',
  'all-reports': 'library',
  'my-reports': 'library',
  favorites: 'library',
  'shared-with-me': 'library',
  templates: 'library',
  // `?tab=pipeline` has been a link into pipeline reporting since before this page existed.
  // It lands on the library and opens Report Studio, which is where it always meant to go.
  pipeline: 'library',
  schedules: 'schedules',
  subscriptions: 'schedules',
  deliveries: 'deliveries',
  'delivery-history': 'deliveries',
  branding: 'branding',
  'report-branding-guidelines': 'branding',
  settings: 'branding',
}

export function resolveTab(param: string | null | undefined): { tab: ReportingTab; openStudio: boolean } {
  const key = String(param ?? '').trim().toLowerCase().replace(/\s+/g, '-')
  return { tab: ALIASES[key] ?? 'library', openStudio: key === 'pipeline' }
}

/** What goes in the address bar for a tab. The library is the bare address. */
export function tabParam(tab: ReportingTab): string | null {
  return tab === 'library' ? null : tab
}
